
Vue.prototype.$tools = {
  objectToKeyVal(obj = { name: 'joe', age: 12 }) {
    let str = '';
    for (let item in obj) {
      str += `${item}=${obj[item]}&`;
    }
    return str;
  },
    //uuid
  guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4())
  },
  // 图片地址含|-*replaceCdn*-|的替换为图片域名
  imgCdnReplace(data) {
    const _imgCdn = process.env.VUE_APP_IMG_CDN
    const _imgstr = '|-*replaceCdn*-|'
    if (typeof data === 'string') {
      if (data.indexOf(_imgstr) !== -1) return data.replaceAll(_imgstr, _imgCdn)
      return data
    } else if (typeof data === 'object') {
      for (let key in data) {
        data[key] = imgCdnReplace(data[key])
      }
    } else if (Array.isArray(data)) {
      data = data.map(item => imgCdnReplace(item))
    }
    return data
  }
}